import React from "react"

import { ACTIVITY_TYPES, QUICK_ACTION_TYPES } from "./types"

/**
 * Top-of-feed action bar. Each button picks an entry type — the parent
 * mounts the composer in response. (Composer-on-click pattern.)
 *
 * `types` is an array of activity-type ids. Defaults to the enquiry set
 * (`QUICK_ACTION_TYPES`); the booking surface passes its own extended
 * set to expose amendment / complaint / feedback / document-sent types.
 */
export default function QuickActions({ activeType, onPick, types = QUICK_ACTION_TYPES }) {
	return (
		<div className="enquiry-quick-actions">
			{types.map((type) => {
				const meta = ACTIVITY_TYPES[type]
				const isActive = activeType === type
				return (
					<button
						key={type}
						type="button"
						className={[
							"enquiry-quick-action",
							meta.badge ? `is-${meta.badge.toLowerCase()}` : "is-default",
							isActive ? "is-active" : "",
						].join(" ")}
						onClick={() => onPick(type)}>
						{meta.label}
					</button>
				)
			})}
		</div>
	)
}
